<div class="row">
  <div class="col">
    <button class='btn btn-info' (click)='newOpportunity()'>New Opportunity</button>
  </div>
</div>

<div class="bg-primary pb-3">
  <app-grid
    entity='opportunity'
    [filters]='this.oppFilters'
    [columns]='this.oppColumns'
    [buttons]='this.oppButtons'
    [searchFilters]='this.oppSearchFilters'
    [searchFields]='this.oppSearchFields'
></app-grid>
</div>
